<template>
    <section class="enterprise-map position-relative">

        <!--персональный фильтр-->
        <div class="custom-select d-none">
            <div class="custom-select__filter d-flex align-items-center">
                <v-select v-if="categories"
                          :items="categories"
                          :item-text="'name'"
                          :item-value="'id'"
                          return-object
                          v-model="selectedCategory"
                          name="selectedCategory"
                          :label="selectedCategory.name"
                          @change="changeMapImg"
                >
                    <template slot="selection" slot-scope="data">
                        {{ data.item.name }}
                    </template>

                    <template slot="item" slot-scope="data">
                        <a @click.prevent="sendFilter(data.item)" class="custom-select__link">
                            {{ data.item.name }}
                        </a>
                    </template>
                </v-select>

            </div>
        </div>
        <!--персональный фильтр-->

        <v-tabs v-model="tab" class="mb-35" @change="changeTab"
                next-icon="mdi-arrow-right-bold-box-outline"
                prev-icon="mdi-arrow-left-bold-box-outline"
                show-arrows>
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="item in items">
                    <span class="enterprise-map__tab">
                           {{ item.label }}
                    </span>
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in items">
                <v-card flat>

                    <div class="enterprise-map__content position-relative">

                        <div class="сlickСoordinates">&#10004; Координаты клика скопированы в буфер!</div>

                        <div class="position-relative">
                            <img class="enterprise-map__img" :src="mapImg" alt="">
                            <div class="enterprise-map__dots-container">
                                <div class="enterprise-map__dots"
                                     v-for="(dot, idx) of item.dots"
                                     :key="idx"
                                     :class="{ 'is-active': (item.point === idx || (item.point === null && idx === 0)) && item.panelOpen }"
                                     :style="{ left: `${dot.dotX}%`, top: `${dot.dotY}%` }"
                                     @click="handleDotClick(item, idx)"
                                >
                                    <div class="enterprise-map__dot">
                                        <img v-if="item.img_type == 'Производство'" src="/upload/production.svg" alt="">
                                        <img v-if="item.img_type == 'Склад'" src="/upload/storage.svg" alt="">
                                        <img v-if='item.img_type == ""' :src="dot.img_url" alt="">
                                        <!--кастомная картинка svg -->

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="enterprise-map__info"
                             :class="{ 'is-hidden': !item.panelOpen }">
                            <button @click="closeInfoPanel(item)" class="enterprise-map__close" type="button">X</button>
                            <div v-for="(info, idx) in item.dots"
                                 :key="idx"
                                 class="enterprise-map__card enterprise"
                                 :class="{ 'is-active': (item.point === idx || (item.point === null && idx === 0)) && item.panelOpen }"
                            >
                                <div style="overflow-y: scroll; overflow-x: hidden">
                                    <div class="enterprise__card" v-for="(detail, index) of  info.contentInfo"
                                         :key="index">
                                        <div class="enterprise__top">
                                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                        d="M26.0439 26.041H22.8243C22.1583 26.041 21.6172 26.5813 21.6172 27.2481C21.6172 27.9159 22.1583 28.4553 22.8243 28.4553H26.0439C26.71 28.4553 27.2519 27.9159 27.2519 27.2481C27.2519 26.5806 26.71 26.041 26.0439 26.041Z"
                                                        fill="#FA4237"/>
                                                <path
                                                        d="M32.1903 26.041H28.8713C28.2052 26.041 27.6641 26.5813 27.6641 27.2481C27.6641 27.9159 28.2052 28.4553 28.8713 28.4553H32.1903C32.8563 28.4553 33.3959 27.9159 33.3959 27.2481C33.3959 26.5806 32.8563 26.041 32.1903 26.041Z"
                                                        fill="#FA4237"/>
                                                <path
                                                        d="M8.27014 15.6155H18.8839C19.551 15.6155 20.0911 15.0756 20.0911 14.4087C20.0911 13.741 19.551 13.2012 18.8839 13.2012H8.27014C7.60318 13.2012 7.0625 13.741 7.0625 14.4087C7.06236 15.0755 7.60305 15.6155 8.27014 15.6155Z"
                                                        fill="#FA4237"/>
                                                <path
                                                        d="M38.7911 37.3378H37.2137V16.9752C37.2137 16.3082 36.6718 15.7676 36.0057 15.7676H33.393V3.45178C33.393 2.78483 32.8519 2.24414 32.186 2.24414H28.8669C28.2008 2.24414 27.6597 2.78483 27.6597 3.45178V15.7676H26.5981V3.45178C26.5981 2.78483 26.0561 2.24414 25.39 2.24414H22.0718C21.4058 2.24414 20.8654 2.78483 20.8654 3.45178V15.7676H3.99433C3.32738 15.7676 2.78587 16.3082 2.78587 16.9752V37.3378H1.20764C0.54 37.3378 0 37.8781 0 38.5467C0 39.2137 0.539863 39.7539 1.20764 39.7539H3.99433H8.27393H18.8877H36.0066H38.7928C39.4589 39.7539 40 39.2137 40 38.5467C39.999 37.8773 39.4589 37.3378 38.7911 37.3378ZM9.4802 37.3378V28.4556H17.6784V37.3378H9.4802Z"
                                                        fill="#FA4237"/>
                                            </svg>
                                            <div class="enterprise__name">
                                                <span class="enterprise__subtitle">{{ detail.type }}</span>
                                                <p>{{ detail.name }}</p>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="enterprise__block">
                                            <span class="enterprise__subtitle">Адрес</span>
                                            <p>{{ detail.address }}</p>
                                        </div>
                                        <hr v-if="detail.products">
                                        <div class="enterprise__block" v-if="detail.products">
                                            <span class="enterprise__subtitle">Продукты</span>
                                            <p>{{ detail.products }}</p>
                                        </div>
                                        <hr v-if="detail.services">
                                        <div class="enterprise__block" v-if="detail.services">
                                            <span class="enterprise__subtitle">Услуги</span>
                                            <p>{{ detail.services }}</p>
                                        </div>
                                        <hr>
                                        <a v-if="detail.url" :href="detail.url" class="enterprise__btn">
                                            Подробнее
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </section>
</template>

<script>


export default {
    name: "enterpriseMap",

    props: {
        units: String | Array | Object,
    },
    data() {
        return {
            tab: null,
            mapImg: '/upload/map_img.svg',
            selectedCategory: {name: "Россия", id: "123"},
            categories: [
                {name: "Россия", id: "123"},
                {name: "Казахстан", id: "120"},
                {name: "Беларусь", id: "121"},
            ],
            /*items: [
              {
                label: "Все",
                point: null,
                panelOpen: true,
                dots: [
                  {
                    dotX: "11",
                    dotY: "30",
                    contentInfo: [
                      {
                        type: "Производственная площадка",
                        name: 'NOVAROLL Оргсинтез Пролаб',
                        url: '/map',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                      {
                        type: "Производственная площадка2",
                        name: 'Название площадки 2',
                        url: '/map',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                    ],
                  },
                  {
                    dotX: "50",
                    dotY: "40",
                    contentInfo: [
                      {
                        type: "Производственная площадка3",
                        name: 'NOVAROLL Оргсинтез Пролаб 3',
                        url: '/map',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                      {
                        type: "Производственная площадка4",
                        name: 'NOVAROLL Оргсинтез Пролаб4',
                        url: '/',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                    ],
                  },
                  {
                    dotX: "17",
                    dotY: "10",
                    contentInfo: [
                      {
                        type: "Производственная площадка",
                        name: 'NOVAROLL Оргсинтез Пролаб',
                        url: '/',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                      {
                        type: "Производственная площадка2",
                        name: 'NOVAROLL Оргсинтез Пролаб2',
                        url: '/',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                    ],
                  },
                ],
              },
              {
                label: "Транспортная упаковка",
                point: null,
                panelOpen: true,
                dots: [
                  {
                    dotX: "42",
                    dotY: "32",
                    contentInfo: [
                      {
                        type: "Производственная площадка",
                        name: 'NOVAROLL Оргсинтез Пролаб',
                        url: '/',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А sdfsdf',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                      {
                        type: "Производственная площадка2",
                        name: 'NOVAROLL Оргсинтез Пролаб 2',
                        url: '/',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        phone: '8 (800) 100-57-51',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                    ],
                  },
                  {
                    dotX: "50",
                    dotY: "27",
                    contentInfo: [
                      {
                        type: "Производственная площадка",
                        name: 'NOVAROLL Оргсинтез Пролаб',
                        url: '/',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                      {
                        type: "Производственная площадка2",
                        name: 'NOVAROLL Оргсинтез Пролаб2',
                        url: '/',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                    ],
                  },
                  {
                    dotX: "33",
                    dotY: "10",
                    contentInfo: [
                      {
                        type: "Производственная площадка",
                        name: 'NOVAROLL Оргсинтез Пролаб2',
                        url: '/',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                      {
                        type: "Производственная площадка2",
                        name: 'NOVAROLL Оргсинтез Пролаб2',
                        url: '/',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                    ],
                  },
                ],
              },
              {
                label: "Потребительская упаковка",
                point: null,
                panelOpen: true,
                dots: [
                  {
                    dotX: "35",
                    dotY: "30",
                    contentInfo: [
                      {
                        type: "Производственная площадка",
                        name: 'NOVAROLL Оргсинтез Пролаб',
                        url: '/',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                      {
                        type: "Производственная площадка2",
                        name: 'NOVAROLL Оргсинтез Пролаб',
                        url: '/',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                    ],
                  },
                  {
                    dotX: "50",
                    dotY: "10",
                    contentInfo: [
                      {
                        type: "Производственная площадка",
                        name: 'NOVAROLL Оргсинтез Пролаб',
                        url: '/',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                      {
                        type: "Производственная площадка2",
                        name: 'NOVAROLL Оргсинтез Пролаб2',
                        url: '/',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                    ],
                  },
                ],
              },
              {
                label: "Химические решения",
                point: null,
                panelOpen: true,
                dots: [
                  {
                    dotX: "35",
                    dotY: "30",
                    contentInfo: [
                      {
                        type: "Производственная площадка",
                        name: 'NOVAROLL Оргсинтез Пролаб',
                        url: '/',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                    ],
                  },
                ],
              },
              {
                label: "Этикеточные решения",
                point: null,
                panelOpen: true,
                dots: [
                  {
                    dotX: "20",
                    dotY: "50",
                    contentInfo: [
                      {
                        type: "Производственная площадка",
                        name: 'NOVAROLL Оргсинтез Пролаб',
                        url: '/',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                      {
                        type: "Производственная площадка2",
                        name: 'NOVAROLL Оргсинтез Пролаб',
                        url: '/',
                        address: 'Нижегородская обл. г.Дзержинск\n' +
                            'Восточное шоссе 88А',
                        products: 'Акриловые дисперсии различного применения, чистые акрилаты, контрактное производство СТМ',
                      },
                    ],
                  },
                ],
              },

            ],*/
            items: this.units,
        }
    },
    methods: {
        changeTab() {
            // console.log("changeTab")
        },
        handleDotClick(item, idx) {
            // Если кликнули на уже открытую точку - закрываем панель
            if (item.point === idx && item.panelOpen) {
                this.closeInfoPanel(item);
                return;
            }
            // Иначе открываем панель
            item.point = idx;
            item.panelOpen = true;
        },
        sendFilter(selected) {
            this.selectedCategory = selected;
            this.changeMapImg(selected);
            console.log("selected", selected);
        },
        changeMapImg(selected) {
            // Меняем карту в зависимости от выбранной категории
            // selected может быть undefined при первом рендере, используем this.selectedCategory
            const category = selected || this.selectedCategory;
            if (category && category.id) {

                this.mapImg = '/upload/map_img.svg';
            }
        },
        openInfoPanel() {
            const currentItem = this.items.find(item => item.point !== null);
            if (currentItem) {
                currentItem.panelOpen = true;
            }
        },
        closeInfoPanel(item) {
            if (!item) return;

            // Закрываем панель для конкретного item
            item.point = null;
            item.panelOpen = false;
        },
    },
}
</script>


<style lang="scss" scoped>
//стили для табов лежат в  business-areas!!!

.enterprise-map {

  &__select {
    margin: 32px 0;
  }

  &__content {
    border-radius: 40px !important;
    background: #F5F5F7;
  }

  &__close {
    position: absolute;
    top: 0;
    left: 0px;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 1px solid #F1F1F1;
    background: #FFFFFF;
    color: #52525B;

    :focus,
    :hover {
      opacity: 0.7;
    }

    @media (max-width: 900px) {
      top: 0;
      left: unset;
      right: 0;
      z-index: 10;
    }

    @media (max-width: 550px) {
      display: none;
    }
  }

  &__card {
    width: 100%;
    max-width: 508px;
    height: calc(100% - 10px);
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    border-radius: 40px;
    padding: 28px;
    padding-right: 13px;
    position: absolute;
    top: 0;
    right: 0;
    transform: translateX(calc(100% + 60px));
    opacity: 0;
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s ease;
    pointer-events: none;

    &.is-active {
      transform: translateX(0);
      opacity: 1;
      pointer-events: auto;
    }

    @media (max-width: 1440px) {
      max-width: 400px;
    }

    @media (max-width: 1024px) {
      max-width: 300px;
    }

    @media (max-width: 900px) {
      max-width: calc(100% - 10px);
      max-height: 500px;
      position: relative;
      transform: translateX(100%);
      margin: 0 auto;
      border: 1px solid #E8E8E8;
      display: none;

      &.is-active {
        transform: translateX(5px);
        display: block;
        overflow: scroll;
      }
    }

    @media (max-width: 550px) {
      max-height: 300px;
    }

    @media (max-width: 425px) {
      padding: 24px;
    }
  }

  &__info {
    position: absolute;
    top: 5px;
    right: 5px;
    display: flex;
    flex-direction: column;
    align-items: start;
    height: 100%;
    max-height: 960px;
    margin-top: 0 !important;
    padding-left: 60px;
    overflow: hidden;
    width: 100%;
    max-width: 558px;

    &.is-hidden {
      display: none !important;
    }

    @media (max-width: 1440px) {
      max-width: 460px;
    }

    @media (max-width: 1024px) {
      max-width: 360px;
    }

    @media (max-width: 900px) {
      position: relative;
      max-width: unset;
      padding: 0;
      max-height: 507px;
    }

    @media (max-width: 550px) {
      max-height: 307px;
    }
  }

  &__dots-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }


  &__img {
    border-radius: 40px;
    max-width: 1840px;
    width: 100%;
    height: 100%;
    //max-height: 790px;
    max-height: 100%;
    object-fit: cover;
  }

  &__dots {
    position: absolute;
    cursor: pointer;
    z-index: 10;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.1);
    }

    &.is-active {
      z-index: 11;

      .enterprise-map__dot {
        background: #fff !important;
        border: 1px solid #212424;

        img {
          width: 17px;
          -ms-filter: none;
          filter: none;
        }

      }
    }
  }

  &__dot {
    position: absolute;
    background: #FA4237;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 17px;
      -ms-filter: brightness(0) invert(1);
      filter: brightness(0) invert(1);
    }
  }

  & .enterprise {

    &__card {
      background: #F5F5F7;
      border-radius: 20px;
      padding: 20px;
      margin-bottom: 16px;
      margin-right: 7px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }


    &__top {
      display: flex;
      align-items: center;
      gap: 20px;

      & svg {
        width: 54px;
        height: 40px;
      }
    }


    &__block {
      display: flex;
      flex-direction: column;
      align-items: start;
    }

    &__name > p {
      font-family: 'RobotoRegular';
      font-weight: 600;
      font-size: 22px;
      line-height: 30px;
      letter-spacing: 0px;
      vertical-align: middle;
      color: #212424;
      margin: 0 !important;
    }

    &__block > p {
      display: inline-block;
      font-family: 'RobotoRegular';
      font-weight: 400;
      font-size: 18px;
      line-height: 26px;
      letter-spacing: -0.05px;
      vertical-align: middle;
      color: #212424;
      margin: 0 !important;
    }

    &__subtitle {
      font-family: 'RobotoRegular';
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0px;
      margin-bottom: 8px;
      color: #4F4D55;
    }

    &__btn {
      display: flex;
      align-items: center;
      gap: 10px;
      text-decoration: underline transparent;
      transition: all 0.3s ease;

      &:hover {
        text-decoration: underline #FA4237;
      }

      @media (max-width: 500px) {
        font-size: 14px;
      }

      & svg {
        width: 32px;
        height: 32px;

        @media (max-width: 500px) {
          width: 22px;
          height: 22px;
        }
      }
    }
  }
}

</style>

<style lang="scss">

.сlickСoordinates {
  display: none;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  padding: 8px;
  margin: 10px;
  background: #c9c9c9;
  border-radius: 6px;
  color: #fff;
  font-family: 'RobotoRegular';
}

.cursor-custom {
  cursor: crosshair;
}

.v-menu__content > .v-list .v-list-item--active {
  color: #D8D8D8 !important;
}

.custom-select {
  margin: 20px 0;
  margin-bottom: 35px;

  &__filter {
    width: max-content;
    padding: 10px 12px 5px 12px;
    border: 1px solid #DCDCDE;
    color: #4F4D55;
    border-radius: 29px;
    max-height: 40px;

    @media (max-width: 500px) {
      max-height: 50px;
      max-width: 100%;
    }
  }

  &__link {
    color: #595959 !important;
    width: 100%;
  }

  .v-list .v-list-item--active {
    background: #FFFFFF !important;
  }

  .v-list .v-list-item--active, .v-list .v-list-item--active .v-icon {

    & .enterprise-map__dot {
      background: #FA4237 !important;
      color: #FF4237 !important;
      caret-color: #FFF8F8 !important;
    }

  }

  .v-list .v-list-item--active {
    color: inherit !important;
  }

  .v-select__selections {
    font-family: 'MuseoSansCyrl-500';
  }

  .v-sheet.v-list {
    & .primary--text {
      color: #FF4237 !important;
      caret-color: #FFF8F8 !important;
    }
  }

  .v-menu {
    display: block;
  }

  .v-menu__content {
    top: 35px !important;
    left: 0 !important;
  }

  .v-input .v-label {
    visibility: hidden;
  }

  .v-text-field > .v-input__control > .v-input__slot:before, .v-text-field > .v-input__control > .v-input__slot:after {
    content: unset;
  }

  .v-select.v-text-field:not(.v-text-field--single-line) input {
    display: none;
  }

  .v-select__slot {
    gap: 10px;
    min-width: 130px;
    justify-content: flex-end;
  }

  .v-select__selections {
    flex: unset;
    width: max-content;
    color: #595959 !important;
  }
}
</style>